module.exports = __webpack_public_path__ + "img/2019jucan-5.cc0b13c9.jpg";